export default __webpack_public_path__ + "static/media/exclaim.965fc3da.svg";